import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/embedded')({
  component: lazyRouteComponent(() => import('./-embedded.lazy'), 'default'),
});
